import React, { FC } from 'react';
import { Control } from 'react-hook-form';

import { ChevronDownIcon } from '../../../assets/icons/index';
import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import {
  ComboboxButton,
  ComboboxOptions,
  FormCombobox,
  FormComboboxInput,
  FormComboboxOption,
} from '../../../components/combobox/index';
import { useLocale } from '../../../hooks/index';
import { SharePlanType, sharePlanTypeTitle } from '../../../types/pool-plans.types';
import { FormSchema } from './plan-form.validation';

export type SharePlanTypeItemsListProps = {
  control: Control<FormSchema>;
};

const SharePlanTypeItemsList: FC<SharePlanTypeItemsListProps> = ({ control }) => {
  return (
    <>
      {Object.entries(sharePlanTypeTitle)
        .filter(([key]) => key !== SharePlanType.SAR)
        .map(([key, value]) => (
          <FormComboboxOption control={control} key={key} name="stepOne.type" value={key}>
            <span className="text-sm text-gray-700">{<AppFormattedMessage id={value} />}</span>
          </FormComboboxOption>
        ))}
    </>
  );
};

export type SharePlanTypeComboboxProps = {
  control: Control<FormSchema>;
  onSelect?: (state: FormSchema['stepOne']['type']) => void;
};

export const SharePlanTypeCombobox: FC<SharePlanTypeComboboxProps> = ({ control, onSelect }) => {
  const { messagesLocale } = useLocale();
  return (
    <FormCombobox className="relative" control={control} name={'stepOne.type'} onSelect={onSelect}>
      <div className="relative">
        <FormComboboxInput
          className={'bg-gray-900'}
          control={control}
          customValue={(value) =>
            value ? messagesLocale[sharePlanTypeTitle[value as SharePlanType]] : value
          }
          icon={<ChevronDownIcon className="mt-2" />}
          name={'stepOne.type'}
          placeholder={<AppFormattedMessage id="EQUITY_PLAN_TYPE" />}
          readOnly
        />
        <ComboboxButton className="absolute left-0 top-0 z-1 h-full w-full" />
      </div>
      <ComboboxOptions className="w-full">
        <SharePlanTypeItemsList control={control} />
      </ComboboxOptions>
    </FormCombobox>
  );
};
